// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NnmC","content":"styles_content__6rybo","tableWrap":"styles_tableWrap__k6O7H"};